import { TrustedPartner } from '../types';
import { TrustedPartnersRepository } from '../repository/TrustedPartnersRepository';


export class TrustedPartnersService {
  constructor(private repository: TrustedPartnersRepository) {}


  public async getPartnersGroupedByCategory(): Promise<Record<string, TrustedPartner[]>> {
    const partners = await this.repository.getAllPartners();
    console.log({ step: 1, partners });
    return this.groupPartnersByCategory(partners);
  }


  public async getCategories(): Promise<string[]> {
    const partners = await this.repository.getAllPartners();
    console.log({step: 2, partners });
    return [...new Set(partners.map(partner => partner.category))];
  }


  private groupPartnersByCategory(partners: TrustedPartner[]): Record<string, TrustedPartner[]> {
    return partners.reduce((grouped, partner) => {
      if (!grouped[partner.category]) {
        grouped[partner.category] = [];
      }
      grouped[partner.category].push(partner);
      return grouped;
    }, {} as Record<string, TrustedPartner[]>);
  }
}


